import { Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, Text, makeStyles, DialogActions, Button} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  card: {
    width: "440px"
  },
  title: {
    textAlign: 'center'
  },
  content: {
    textAlign: 'center'
  },
  button: {
    boxShadow: "0px 4px 4px #00000025",
  }
});

export interface ServiceUnavailableDialogProps {
    title: string;
	message: string;
	open: boolean;
}

export const ServiceUnavailableDialog = (props: ServiceUnavailableDialogProps) => {
  const { open, title, message } = props;
  const styles = useStyles();
  const navigate = useNavigate();
  return (
    <Dialog modalType="non-modal" open={open}>
      <DialogSurface className={styles.card}>
        <DialogBody>
          <DialogTitle className={styles.title} action={null}>
            {title}
          </DialogTitle>
          <DialogContent className={styles.content}>
            <Text >
              {message}
            </Text>
          </DialogContent>
          <DialogActions>
            <Button
              className={styles.button} 
              onClick={() => navigate("/tab")}
            >
              Close
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
